/**
 * Build-time + runtime flags for the portal. Sandbox Pages bake VITE_* at
 * `ship:sandbox`; the hostname check is a second belt so a mis-baked bundle
 * still labels itself when served from *-sandbox.pahfacturar.com.
 */

export function isBillingEnabled(): boolean {
  return import.meta.env.VITE_BILLING_ENABLED !== "false";
}

export function isSandboxHost(): boolean {
  if (typeof window === "undefined") {
    return import.meta.env.VITE_SANDBOX === "true";
  }
  return (
    import.meta.env.VITE_SANDBOX === "true" ||
    window.location.hostname.includes("-sandbox.")
  );
}
